import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const OvHormonePatternDisclosure: FC = () => {
  const { t } = useTranslation();

  return <Caption>{t('patientDetails.hormonePatterns.disclosure')}</Caption>;
};

export default OvHormonePatternDisclosure;

const Caption = styled.p`
  margin: 0.75rem 0 0;
  color: ${Colours.OV_PRUSSIAN_BLUE};
  font-size: ${Variables.fontSizes.SMALL};
  line-height: ${Variables.lineHeights.LARGE};
`;
